import api from '../services/api'
import { RESET } from '../redux/game'
import { TEAM_CHANGED } from '../redux/team'

// Actions
const FETCHING_PEER_INSIGHTS_START = 'ascension/peer-insights/fetching'
const FETCHING_PEER_INSIGHTS_SUCCESS = 'ascension/peer-insights/success'
const FETCHING_PEER_INSIGHTS_ERROR = 'ascension/peer-insights/error'
const SET_CURRENT_SCREEN = 'ascension/peer-insights/set-screen'
const SET_CURRENT_PAGE = 'ascension/peer-insights/set-page'
const SET_ACTIVE_BUSINESS = 'ascension/peer-insights/set-active-business'
const TOGGLE_MARKET_SHARE = 'ascension/peer-insights/toggle-market-share'

// Reducer
const initialState = {
  isLoading: false,
  isLoaded: false,
  currentPage: 0,
  error: null,
  currentScreen: [0, 0],
  activeBusiness: null,
  marketShare: false,
  data: {}
}

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCHING_PEER_INSIGHTS_START: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
        error: null,
        data: {
          ...state.data,
          [`${action.data.round}`]: null
        }
      }
    }
    case FETCHING_PEER_INSIGHTS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        data: {
          ...state.data,
          [`${action.data.round}`]: action.data.data
        }
      }
    }
    case FETCHING_PEER_INSIGHTS_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.data
      }
    }
    case SET_CURRENT_SCREEN: {
      return {
        ...state,
        currentScreen: state.currentScreen.map((item, i) => {
          if (i === action.data.page) {
            return action.data.screenIndex
          }
          return item
        })
      }
    }
    case SET_CURRENT_PAGE: {
      return {
        ...state,
        currentPage: action.data
      }
    }
    case SET_ACTIVE_BUSINESS: {
      return {
        ...state,
        activeBusiness: action.data
      }
    }
    case TOGGLE_MARKET_SHARE: {
      return {
        ...state,
        marketShare: !state.marketShare
      }
    }
    case RESET:
    case TEAM_CHANGED: {
      return initialState
    }
    default: return state
  }
}

export default reducer

export function fetchingPeerInsightsStart (round) {
  return {
    type: FETCHING_PEER_INSIGHTS_START,
    data: { round }
  }
}

export function fetchingPeerInsightsSuccess (data, round) {
  return {
    type: FETCHING_PEER_INSIGHTS_SUCCESS,
    data: { data, round }
  }
}

export function setCurrentScreen (screenIndex, page) {
  return {
    type: SET_CURRENT_SCREEN,
    data: { screenIndex, page }
  }
}

export function fetchingPeerInsightsError (error) {
  return {
    type: FETCHING_PEER_INSIGHTS_ERROR,
    data: error
  }
}

export function updatePage (page) {
  return {
    type: SET_CURRENT_PAGE,
    data: page
  }
}

export function setActiveBusiness (business) {
  return {
    type: SET_ACTIVE_BUSINESS,
    data: business
  }
}

export function toggleMarketShare () {
  return {
    type: TOGGLE_MARKET_SHARE
  }
}

// Action Creators
export function fetchPeerInsights (team, round) {
  return async (dispatch) => {
    dispatch(fetchingPeerInsightsStart(round))

    try {
      const response = await api.getPeerInsights(team, round)
      dispatch(fetchingPeerInsightsSuccess(response, round))
    } catch (e) {
      dispatch(fetchingPeerInsightsError(e))
    }
  }
}
